import { Course } from 'interfaces/Course'
import { AnalyticsEventUniversityFeatureButtonClick } from 'lib/constants/AnalyticsEventType'
import { appCreateKnowsOptionRoute, appSchoolGptRoute, signUpRoute } from 'lib/constants/routes'
import { trackEvent } from 'lib/tracking/analytics-service'

export const getCoursesPreview = (
    courses: Course[],
    fullWidth: boolean,
    defaultText: string,
    maxVisibleCourses = 2
): string => {
    if (courses.length === 0) {
        return defaultText
    }

    if (!fullWidth || courses.length <= maxVisibleCourses) {
        return courses.map((c) => c.name).join(', ')
    }

    const visibleCourses = courses
        .slice(0, maxVisibleCourses)
        .map((c) => c.name)
        .join(', ')
    const remaining = courses.length - maxVisibleCourses
    return `${visibleCourses} +${remaining}`
}

export const getDefaultReviews = () => {
    return [
        {
            name: '7|Tommy|7',
            text: 'Mega Geil! Bin mega begeistert. Mit der App kann man super lernen und es ist auch alles vollständig enthalten! Danke an den Entwickler und dem KnowunityTeam',
            stars: 5,
        },
        {
            name: 'Niki42',
            text: 'Beste App! Ich habe sie allen meinen Freunden gezeigt und alle sind mindestens genau so überzeugt wie ich. Vallah Leute vertraut mir die ist zu krass wegen dieser App bin ich von 3-4 Noten auf 1-2 gekommen.',
            stars: 4,
        },
        {
            name: 'carlotchen',
            text: 'Ich finde Knowunity super!!! Alles was ich brauche ist auf dieser app es gibt Merkzettel,Rechenwege einfach Hilfe bei jeder Kleinigkeit! ',
            stars: 5,
        },
        {
            name: 'LenaStudiert',
            text: 'Die App ist einfach super! Ich muss nur in die Suchleiste mein Thema eintragen und ich checke es sehr schnell. Ich muss nicht mehr 10 YouTube Videos gucken, um etwas zu verstehen und somit spare ich mir meine Zeit. Einfach zu empfehlen!!',
            stars: 5,
        },
        {
            name: 'MaxMathe123',
            text: 'Diese App hat mich echt verbessert! In der Schule war ich richtig schlecht in Mathe und dank der App kann ich besser Mathe! Ich bin so dankbar, dass ihr die App gemacht habt.',
            stars: 5,
        },
        {
            name: 'AbiGirl2024',
            text: 'Die App ist soo geil. Alle Themen sind so gut zusammengefasst. Alles, was man wissen muss, steht schon drin. Außerdem haben sich meine Noten verbessert. So gut und so hilfreiche Hilfe wie Knowunity hatte ich noch nie. Dankeee sehr Knowunity!',
            stars: 5,
        },
        {
            name: 'StudiMaus',
            text: 'Diese App ist einfach nur toll, ich konnte damit schon sehr viel lernen. Ich kann diese App einfach nur jedem weiterempfehlen, der Schwierigkeiten in der Schule hat. Man kann damit sehr viel lernen.',
            stars: 4,
        },
        {
            name: 'JuliaSchulstress',
            text: 'Ich liebe diese App so sehr, ich benutze sie auch täglich. Ich empfehle Knowunity jedem!! Ich bin damit von einer 4 auf eine 1 gekommen :D',
            stars: 5,
        },
        {
            name: 'TimoLernt',
            text: 'Ich finde Knowunity ist eine super App. Für die Schule ist sie ideal, wegen den Lernzetteln, Quizen und dem AI. Das gute an AI ist, dass er nicht direkt nur die Lösung ausspuckt sondern einen Weg zeigt wie man darauf kommt.',
            stars: 5,
        },
        {
            name: 'SarahAbi',
            text: 'Mit dieser App hab ich bessere Noten bekommen. Bessere Lernzettel gekriegt. Ich habe die App benutzt, als ich die Fächer nicht ganz verstanden habe, diese App ist ein wirklich GameChanger für die Schule!',
            stars: 4,
        },
        {
            name: 'MarcusStudent',
            text: 'Also die App hat mir echt in super vielen Fächern geholfen! Ich hatte in der Mathe Arbeit davor eine 3+ und habe nur durch den School GPT und die Lernzettel auf der App eine 1-3 in Mathe geschafft. Ich bin mega glücklich darüber!',
            stars: 5,
        },
        {
            name: 'AnnaKlasse10',
            text: 'Hatte noch nie so viel Spaß beim Lernen und der School Bot macht super Aufschriebe die man herunterladen kann - total übersichtlich und lehrreich. Bin begeistert.',
            stars: 5,
        },
    ]
}

export const onUniversityFeatureButtonClick = (type: 'uni-gpt' | 'ai-summary' | 'mock-exam', title: string) => {
    trackEvent(AnalyticsEventUniversityFeatureButtonClick, {
        referrerScreen: type,
        value: title,
    })
    window.open(
        signUpRoute({
            referrerScreen: type,
            redirect:
                type === 'uni-gpt'
                    ? appSchoolGptRoute
                    : appCreateKnowsOptionRoute({
                          referrerScreen: type,
                          tab: type === 'mock-exam' ? 'mock-exam' : 'ai-summary',
                      }),
        })
    )
}
